import { NotificationRepository } from './NotificationRepository';
import { SaveFcmTokenUseCase } from './usecases/SaveFcmTokenUseCase';
import { EnqueueNotificationUseCase } from './usecases/EnqueueNotificationUseCase';
import { SupabaseNotificationRepository } from '@infrastructure/supabase/SupabaseNotificationRepository';

class NotificationDomainFactory {
  private repository: NotificationRepository;

  constructor() {
    this.repository = new SupabaseNotificationRepository();
  }

  getSaveFcmTokenUseCase() {
    return new SaveFcmTokenUseCase(this.repository);
  }

  getEnqueueNotificationUseCase() {
    return new EnqueueNotificationUseCase(this.repository);
  }

  getRepository() {
    return this.repository;
  }
}

export const notificationDomain = new NotificationDomainFactory();
